import { useEffect, useState } from "react";
import { Backdrop, Box, Modal } from "@mui/material";
import { MercadoPagoPayment } from "./MercagoPagoCheckout";
import { useNavigate } from "react-router-dom";

interface Props {
  open: boolean;
  setOpen: (val: boolean) => void;
  itensInfo: { totalValue: number; totalItens: number; addressID: number };
  selectedProducts: CartXProduct[];
  cleanStateCart: VoidFunction;
  selectedFrete: { freteType: string; value: string };
  disablePayButton(): void;
}

export function PaymentModal({
  open,
  setOpen,
  itensInfo,
  selectedProducts,
  cleanStateCart,
  selectedFrete,
  disablePayButton,
}: Props) {
  const nav = useNavigate();

  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [seconds, setSeconds] = useState(10);

  // const handleCreateChargeID = async () => {
  //   setLoading(true);
  //   try {
  //     const { error, paymentMethod } = await stripe.createPaymentMethod({
  //       type: "card",
  //       card: elements.getElement(CardElement),
  //     });

  //     if (!error) {
  //       const { id } = paymentMethod;
  //       setChargeID(id);
  //       setCardVerify(true);
  //     } else {
  //       setChargeID("");
  //       setCardVerify(false);
  //     }
  //   } catch {
  //     setError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    let interval = undefined;
    if (paymentSuccess) {
      interval = setInterval(
        () =>
          setSeconds((old) => {
            if (seconds <= 0) return 0;
            else return old - 1;
          }),
        1000
      );
      if (seconds === 0) {
        nav("/user/my-info");
      }
    } else {
      setSeconds(10);
    }

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [paymentSuccess, seconds]);

  // useEffect(() => {
  //   setCardVerify(false);

  //   // eslint-disable-next-line
  // }, [elements?.getElement(CardElement)]);

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
        setPaymentSuccess(false);
        // nav("/user/my-info");
      }}
      slots={{ backdrop: Backdrop }}
    >
      {/* <PaymentSuccess seconds={seconds} />
      {itensInfo.totalValue === 0 ? (
        <Box
          width={"100%"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          <PaymentSuccess seconds={seconds} />
        </Box>
      ) : ( */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            position: "relative",
            borderRadius: 2,
            p: 1,
            maxHeight: "90%",
            width: 734,
            pb: 5,
          }}
        >
          <MercadoPagoPayment
            itensInfo={itensInfo}
            selectedProducts={selectedProducts}
            freteType={selectedFrete}
            disablePayButton={disablePayButton}
          />
        </Box>
      </Box>
      {/* )} */}
    </Modal>
  );
}
